var styles = {
  "EditableLink": "Online-Store-UI-EditableLink_z37v5",
  "Preview": "Online-Store-UI-EditableLink__Preview_1a1hj",
  "Actions": "Online-Store-UI-EditableLink__Actions_yzoou"
};

export { styles as default };
